const number_with_delimiter = (number) => {
  return Number(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export default number_with_delimiter;
